// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TextSubmitForm from '@localytics/loc-components/lib/TextSubmitForm';
import Button from '@localytics/loc-components/lib/Button';
import { chooseOrchestrationName } from './actions/wip';
import './NameNewCampaign.scss';

type Props = {
  dispatch: Function,
  switchPage: Function
};

const placeholder = 'Untitled Workflow';

class NameNewCampaign extends Component<Props> {
  submitInputValue: Function = (input: string) => {
    let name = input;
    if (input === '') {
      name = placeholder;
    }
    this.props.dispatch(chooseOrchestrationName(name));
    this.props.switchPage('chooseAppGroup');
  };

  render() {
    return (
      <div className="Page__Body">
        <div className="Page__Content Page__Content--flexible">
          <div className="NameNewCampaign">
            <h6>NAME THIS WORKFLOW</h6>
            <TextSubmitForm
              submitInputValue={this.submitInputValue}
              placeholder={placeholder}
              allowEmptySubmitValue
              className="TextSubmitForm--large"
              autoFocus
            >
              <Button type="primary" label="Continue to setup" />
            </TextSubmitForm>
            <span className="NameNewCampaign__EnterToContinue">
              Hit <span>↵ Enter</span> to continue
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(NameNewCampaign));



// WEBPACK FOOTER //
// ./src/NameNewCampaign.jsx